<template>
  <div>
    <b-row>
      <b-col>
        <span class="booking-details-title d-block rounded mb-2">
          <p class="mb-0 text-center">Aici poti adauga comisionul agentiei pentru a putea transmite clientului tau oferta in format PDF direct din sistemul nostru de Rezervari. Simplu si rapid!</p>
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <table class="table table-sm table-hover border">
          <thead class="t-head hh-t-head">
            <tr>
              <td>Nr. stele</td>
              <td>Comision/camera/sejur Fix</td>
              <td>Comision/camera/sejur (%)Procentual</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="stars in order" :key="'fee' + stars">
              <td>
                {{ stars ? (stars + '*') : 'Fara clasificare'}}
              </td>
              <td>
                <b-form-group class="mb-0">
                <b-input
                  type="number"
                  v-model="fees[stars].value"
                  size="sm" />
                </b-form-group>
              </td>
              <td>
                <b-form-group class="mb-0">
                <b-input
                  type="number"
                  v-model="fees[stars].percent"
                  size="sm" />
                </b-form-group>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- <small class="ml-3 text-danger">Categoria <b>Fara clasificare</b> se refera la vile, pensiuni sau unitati de cazare ce nu se incadreaza la categoria Hotel.</small> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'HotelFeesEdit',
  props: ['fees'],
  data () {
    return {
      order: [5, 4, 3, 2, 1, 0]
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
